/* eslint max-classes-per-file: 0 */

import {
  Session,
  Subject,
  Procedure,
} from '@/typings/api/CollectorPublication'

import { Mark as Data, MarkCollection as Collection } from '@/typings/api/Marks'

import { Fabric } from '@/store/createCrudModule'
import { PublicationsAdapter } from './PublicationsAdapter'
import { SubjectsAdapter } from './SubjectsAdapter'
import { SessionsAdapter } from './SessionsAdapter'
import { ProceduresAdapter } from './ProceduresAdapter'


export const fabric = Fabric<Data, Collection>()

type S = PublicationsState
type G = PublicationsGetters
type M = PublicationsMutations
type A = PublicationsActions


export class PublicationsState extends fabric.State {
  public sessions: Session[] | null = [];

  public subjects: Subject[] | null = [];

  public procedures: Procedure[] | null = [];
}

export class PublicationsGetters extends fabric.Getters<S> {
}

export class PublicationsMutations extends fabric.Mutations<S> {
  public setSessions(payload?: Session[]) {
    this.state.sessions = payload || []
  }

  public setSubjects(payload?: Subject[]) {
    this.state.subjects = payload || []
  }

  public setProcedures(payload?: Procedure[]) {
    this.state.procedures = payload || []
  }
}

export class PublicationsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new PublicationsAdapter();

  protected readonly subjectsAdapter = new SubjectsAdapter();

  protected readonly sessionsAdapter = new SessionsAdapter();

  protected readonly proceduresAdapter = new ProceduresAdapter();

  protected readonly idName = 'procedure_id';

  public fetchSessions() {
    return this.sessionsAdapter.api.getAll({ pageSize: 100 }).then((result) => this.mutations.setSessions(result.data))
  }

  public fetchSubjects() {
    return this.subjectsAdapter.api.getAll({ pageSize: 100 }).then((result) => this.mutations.setSubjects(result.data))
  }

  public fetchProcedures() {
    return this.proceduresAdapter.api.getAll({}).then((result) => this.mutations.setProcedures(result.data))
  }
}
